module.exports = __webpack_public_path__ + "img/073488.de7d2ec3.png";